(ns frontend.view.modals.folder-selection-modal.event
  (:require
   [frontend.logging :as logging]
   [potpuri.core :as potpuri]
   [re-frame.core :as rf]
   [frontend.controller.websocket.event :as ws]
   [frontend.view.modals.folder-selection-modal.sub :as sub]))


(rf/reg-event-fx
 ::init
 (fn [{db :db} [_ entity folder-names]]
   {:db (-> db
            (assoc ::sub/target-entity (:db/id entity))
            (assoc ::sub/original-path (:attachment/folder-path entity))
            (assoc ::sub/folder-choices folder-names))}))

(rf/reg-event-fx
 ::clear
 (fn [{db :db} _]
   {:db (-> db
            (dissoc ::sub/target-entity
                    ::sub/original-path
                    ::sub/folder-options
                    ::sub/folder-choices
                    ::sub/selected-folder
                    ::sub/processing?))}))

(rf/reg-event-fx
 ::set-selected-folder
 (fn [{db :db} [_ selected-folder]]
   {:db (-> db
            (assoc ::sub/selected-folder selected-folder))}))

;; FIXME: event handler not pure
(rf/reg-event-fx
 ::save-ok
 (fn [{db :db} [_ close-modal! resp]]
   (when (fn? close-modal!)
     (close-modal!))
   {:db (dissoc db ::sub/processing?)}))

(rf/reg-event-fx
 ::save-failed
 (fn [{db :db} [_ resp]]
   (let [error (some->> resp
                        :body
                        :error-message)]
     (logging/warn (str ::save-failed resp))
     {:db (-> db
              (dissoc ::sub/processing?)
              (assoc ::sub/error error))})))

(rf/reg-event-fx
 ::save!
 (fn [{db :db} [_ entity close-modal!]]
   (let [new-path (str "/" (get db ::sub/selected-folder))
         msg {:data  {:attachment/folder-path new-path}
              :db/id (get db ::sub/target-entity)}]
     {:db       (assoc-in db [::sub/processing?] true)
      ::ws/send {:id         :entity/update-attributes
                 :body       msg
                 :on-success [::save-ok close-modal!]
                 :on-error   [::save-failed]}})))
